(() => {
  const SELECTOR = '[data-pb-product-info-tabs]';
  const DESKTOP_QUERY = '(min-width: 990px)';

  class PBProductInfoTabs {
    constructor(section) {
      if (!section || section.dataset.pbTabsInitialized === 'true') return;

      section.dataset.pbTabsInitialized = 'true';
      this.section = section;
      this.buttons = Array.from(section.querySelectorAll('[data-pb-tab-target]'));
      this.panels = Array.from(section.querySelectorAll('[data-pb-panel]'));
      this.mediaQuery = window.matchMedia(DESKTOP_QUERY);

      if (!this.buttons.length || !this.panels.length) return;

      this.onViewportChange = this.onViewportChange.bind(this);
      this.bindEvents();
      this.onViewportChange();
    }

    bindEvents() {
      this.buttons.forEach((button, index) => {
        button.addEventListener('click', () => {
          this.activate(button.dataset.pbTabTarget);
        });

        button.addEventListener('keydown', (event) => {
          this.onTabKeydown(event, index);
        });
      });

      this.panels.forEach((panel) => {
        panel.addEventListener('toggle', () => {
          if (!this.mediaQuery.matches || !panel.open) return;
          this.activate(panel.dataset.pbPanel);
        });
      });

      if (typeof this.mediaQuery.addEventListener === 'function') {
        this.mediaQuery.addEventListener('change', this.onViewportChange);
      } else {
        this.mediaQuery.addListener(this.onViewportChange);
      }
    }

    onTabKeydown(event, currentIndex) {
      const lastIndex = this.buttons.length - 1;
      let nextIndex = null;

      switch (event.key) {
        case 'ArrowRight':
          nextIndex = currentIndex === lastIndex ? 0 : currentIndex + 1;
          break;
        case 'ArrowLeft':
          nextIndex = currentIndex === 0 ? lastIndex : currentIndex - 1;
          break;
        case 'Home':
          nextIndex = 0;
          break;
        case 'End':
          nextIndex = lastIndex;
          break;
        default:
          return;
      }

      event.preventDefault();
      const nextButton = this.buttons[nextIndex];
      nextButton.focus();
      this.activate(nextButton.dataset.pbTabTarget);
    }

    activate(target) {
      if (!target) return;

      this.buttons.forEach((button) => {
        const isActive = button.dataset.pbTabTarget === target;
        button.classList.toggle('is-active', isActive);
        button.setAttribute('aria-selected', isActive ? 'true' : 'false');
        button.setAttribute('tabindex', isActive ? '0' : '-1');
      });

      this.panels.forEach((panel) => {
        panel.open = panel.dataset.pbPanel === target;
      });
    }

    onViewportChange() {
      if (this.mediaQuery.matches) {
        this.enableDesktopTabs();
      } else {
        this.enableMobileAccordions();
      }
    }

    enableDesktopTabs() {
      this.panels.forEach((panel) => {
        const content = panel.querySelector('.pb-product-info-tabs__panel-content');
        const key = panel.dataset.pbPanel;
        const controllingButton = this.buttons.find(
          (button) => button.dataset.pbTabTarget === key
        );

        if (!content || !controllingButton) return;

        content.setAttribute('role', 'tabpanel');
        content.setAttribute('aria-labelledby', controllingButton.id);
        content.setAttribute('tabindex', '0');
      });

      const selectedButton = this.buttons.find(
        (button) => button.getAttribute('aria-selected') === 'true'
      );
      const openPanel = this.panels.find((panel) => panel.open);
      const target =
        selectedButton?.dataset.pbTabTarget ||
        openPanel?.dataset.pbPanel ||
        this.buttons[0]?.dataset.pbTabTarget;

      this.activate(target);
    }

    enableMobileAccordions() {
      this.panels.forEach((panel) => {
        const content = panel.querySelector('.pb-product-info-tabs__panel-content');
        if (!content) return;

        content.removeAttribute('role');
        content.removeAttribute('aria-labelledby');
        content.removeAttribute('tabindex');
      });
    }
  }

  const initialize = (root = document) => {
    root.querySelectorAll(SELECTOR).forEach((section) => {
      new PBProductInfoTabs(section);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initialize());
  } else {
    initialize();
  }

  document.addEventListener('shopify:section:load', (event) => {
    initialize(event.target);
  });
})();
